module.exports = __webpack_public_path__ + "src/assets/img/index_meeting.dd838be2.jpg";